module.exports = __webpack_public_path__ + "img/24.1d0f9028.png";